
// Types
export interface Category {
    id: string;
    name: string;
    slug: string;
    image: string;
    productCount: number;
}

export interface Product {
    id: string;
    name: string;
    slug: string;
    description: string;
    price: number;
    originalPrice?: number;
    images: string[];
    category: {
        id: string;
        name: string;
        slug: string;
    };
    isFeatured: boolean;
    isNew: boolean;
    stock: number;
    unit: string;
    weight: string;
    origin: string;
    disabled?: boolean;
    type?: string;
    nutritionFacts?: Array<{
        name: string;
        value: string;
    }>;
    rating?: number;
    reviewCount?: number;
}



// Mock Data
const CATEGORIES: Category[] = [
    {
        id: '1',
        name: 'Trái cây Việt Nam',
        slug: 'trai-cay-viet-nam',
        image: 'https://images.unsplash.com/photo-1601493700631-2b16ec4b4716?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=775&q=80',
        productCount: 25,
    },
    {
        id: '2',
        name: 'Trái cây nhập khẩu',
        slug: 'trai-cay-nhap-khau',
        image: 'https://images.unsplash.com/photo-1528825871115-3581a5387919?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=830&q=80',
        productCount: 32,
    },
    {
        id: '3',
        name: 'Trái cây cắt sẵn',
        slug: 'trai-cay-cat-san',
        image: 'https://images.unsplash.com/photo-1578829779691-99b60bd8c7be?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80',
        productCount: 18,
    },
    {
        id: '4',
        name: 'Quà tặng trái cây',
        slug: 'qua-tang-trai-cay',
        image: 'https://images.unsplash.com/photo-1519162418598-c48e021559e7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1674&q=80',
        productCount: 15,
    },
];

const PRODUCTS: Product[] = [
    {
        id: '1',
        name: 'Dâu tây Đà Lạt (hộp 250g)',
        slug: 'dau-tay-da-lat',
        description: 'Dâu tây Đà Lạt được trồng trong điều kiện khí hậu mát mẻ của Đà Lạt, tạo nên những quả dâu tây đỏ mọng, ngọt thanh và thơm ngon. Sản phẩm được đóng gói cẩn thận, giữ nguyên hương vị tự nhiên và độ tươi ngon đến tay người tiêu dùng.',
        price: 150000,
        originalPrice: 180000,
        images: [
            'https://images.unsplash.com/photo-1566804335220-b06d4b4438f3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
            'https://images.unsplash.com/photo-1518635017498-87f514b751ba?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1771&q=80',
            'https://images.unsplash.com/photo-1543158181-e6f9f6712055?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80',
            'https://images.unsplash.com/photo-1601000938365-f182c5a3926a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80',
        ],
        category: {
            id: '1',
            name: 'Trái cây Việt Nam',
            slug: 'trai-cay-viet-nam',
        },
        isFeatured: true,
        isNew: true,
        stock: 50,
        unit: 'hộp',
        weight: '250g',
        origin: 'Đà Lạt, Lâm Đồng',
        nutritionFacts: [
            { name: 'Calo', value: '32 kcal / 100g' },
            { name: 'Carbohydrate', value: '7.7g / 100g' },
            { name: 'Chất đạm', value: '0.7g / 100g' },
            { name: 'Chất béo', value: '0.3g / 100g' },
            { name: 'Chất xơ', value: '2g / 100g' },
            { name: 'Vitamin C', value: '59mg / 100g' },
        ],
        rating: 4.8,
        reviewCount: 24,
    },
    {
        id: '2',
        name: 'Táo Envy New Zealand',
        slug: 'tao-envy-new-zealand',
        description: 'Táo Envy nhập khẩu trực tiếp từ New Zealand với vẻ ngoài đỏ thẫm và hương vị ngọt ngào, giòn tan. Mỗi quả táo đều được chọn lọc kỹ lưỡng, đảm bảo chất lượng và vẻ ngoài hoàn hảo.',
        price: 120000,
        images: [
            'https://images.unsplash.com/photo-1619546813926-a78fa6372cd2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80',
            'https://images.unsplash.com/photo-1570913149827-d2ac84ab3f9a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80',
        ],
        category: {
            id: '2',
            name: 'Trái cây nhập khẩu',
            slug: 'trai-cay-nhap-khau',
        },
        isFeatured: true,
        isNew: false,
        stock: 30,
        unit: 'kg',
        weight: '1kg',
        origin: 'New Zealand',
        nutritionFacts: [
            { name: 'Calo', value: '52 kcal / 100g' },
            { name: 'Carbohydrate', value: '14g / 100g' },
            { name: 'Chất đạm', value: '0.3g / 100g' },
            { name: 'Chất béo', value: '0.2g / 100g' },
            { name: 'Chất xơ', value: '2.4g / 100g' },
            { name: 'Vitamin C', value: '4.6mg / 100g' },
        ],
        rating: 4.7,
        reviewCount: 36,
    },
    {
        id: '3',
        name: 'Cherry Mỹ',
        slug: 'cherry-my',
        description: 'Cherry Mỹ là loại quả cao cấp với màu đỏ đậm, thịt quả chắc, mọng nước và vị ngọt đặc trưng. Mỗi quả cherry đều được lựa chọn cẩn thận và đóng gói trong điều kiện tốt nhất để đảm bảo độ tươi khi đến tay khách hàng.',
        price: 350000,
        originalPrice: 390000,
        images: [
            'https://images.unsplash.com/photo-1528821128474-25c5c5873225?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80',
            'https://images.unsplash.com/photo-1559181567-c3190ca9959b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1300&q=80',
        ],
        category: {
            id: '2',
            name: 'Trái cây nhập khẩu',
            slug: 'trai-cay-nhap-khau',
        },
        isFeatured: true,
        isNew: false,
        stock: 15,
        unit: 'hộp',
        weight: '500g',
        origin: 'Mỹ',
        nutritionFacts: [
            { name: 'Calo', value: '63 kcal / 100g' },
            { name: 'Carbohydrate', value: '16g / 100g' },
            { name: 'Chất đạm', value: '1.1g / 100g' },
            { name: 'Chất béo', value: '0.2g / 100g' },
            { name: 'Chất xơ', value: '2.1g / 100g' },
            { name: 'Vitamin C', value: '7mg / 100g' },
        ],
        rating: 4.9,
        reviewCount: 18,
    },
    {
        id: '4',
        name: 'Sầu riêng Ri6 Bến Tre',
        slug: 'sau-rieng-ri6-ben-tre',
        description: 'Sầu riêng Ri6 Bến Tre nổi tiếng với thịt dày, múi vàng óng, vị ngọt đậm và mùi thơm đặc trưng. Được trồng theo phương pháp hữu cơ, không sử dụng chất kích thích, đảm bảo an toàn cho sức khỏe người tiêu dùng.',
        price: 240000,
        images: [
            'https://images.unsplash.com/photo-1588482415422-a061789ffe19?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1769&q=80',
            'https://images.unsplash.com/photo-1622119031517-db914aa3ffc5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1771&q=80',
        ],
        category: {
            id: '1',
            name: 'Trái cây Việt Nam',
            slug: 'trai-cay-viet-nam',
        },
        isFeatured: true,
        isNew: false,
        stock: 8,
        unit: 'kg',
        weight: '1kg',
        origin: 'Bến Tre',
        nutritionFacts: [
            { name: 'Calo', value: '147 kcal / 100g' },
            { name: 'Carbohydrate', value: '27g / 100g' },
            { name: 'Chất đạm', value: '1.5g / 100g' },
            { name: 'Chất béo', value: '5.3g / 100g' },
            { name: 'Chất xơ', value: '3.8g / 100g' },
            { name: 'Vitamin C', value: '19.7mg / 100g' },
        ],
        rating: 4.6,
        reviewCount: 42,
    },
    {
        id: '5',
        name: 'Bưởi da xanh Bến Tre',
        slug: 'buoi-da-xanh-ben-tre',
        description: 'Bưởi da xanh Bến Tre nổi tiếng với vỏ mỏng, màu xanh đặc trưng, múi đỏ hồng, vị ngọt thanh, ít hạt. Sản phẩm được trồng theo tiêu chuẩn VietGAP, đảm bảo an toàn vệ sinh thực phẩm và giữ nguyên hương vị tự nhiên.',
        price: 75000,
        images: [
            'https://images.unsplash.com/photo-1550258987-190a2d41a8ba?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1674&q=80',
            'https://images.unsplash.com/photo-1590492929922-2a616aafd4af?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80',
        ],
        category: {
            id: '1',
            name: 'Trái cây Việt Nam',
            slug: 'trai-cay-viet-nam',
        },
        isFeatured: true,
        isNew: false,
        stock: 25,
        unit: 'piece',
        weight: '~1.5kg/quả',
        origin: 'Bến Tre',
        nutritionFacts: [
            { name: 'Calo', value: '42 kcal / 100g' },
            { name: 'Carbohydrate', value: '10.7g / 100g' },
            { name: 'Chất đạm', value: '0.8g / 100g' },
            { name: 'Chất béo', value: '0.1g / 100g' },
            { name: 'Chất xơ', value: '1.1g / 100g' },
            { name: 'Vitamin C', value: '44mg / 100g' },
        ],
        rating: 4.4,
        reviewCount: 28,
    },
    {
        id: '6',
        name: 'Măng cụt Cái Bè',
        slug: 'mang-cut-cai-be',
        description: 'Măng cụt Cái Bè được mệnh danh là "nữ hoàng của các loại trái cây" với vị ngọt thanh, chua nhẹ, thịt trắng ngà và mọng nước. Sản phẩm được thu hoạch đúng độ chín và đóng gói cẩn thận để đảm bảo chất lượng tốt nhất.',
        price: 90000,
        images: [
            'https://images.unsplash.com/photo-1622208489373-812b142f19e9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80',
            'https://images.unsplash.com/photo-1583169526707-86a5665fff83?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1240&q=80',
        ],
        category: {
            id: '1',
            name: 'Trái cây Việt Nam',
            slug: 'trai-cay-viet-nam',
        },
        isFeatured: false,
        isNew: true,
        stock: 20,
        unit: 'kg',
        weight: '1kg',
        origin: 'Tiền Giang',
        nutritionFacts: [
            { name: 'Calo', value: '63 kcal / 100g' },
            { name: 'Carbohydrate', value: '15.6g / 100g' },
            { name: 'Chất đạm', value: '0.5g / 100g' },
            { name: 'Chất béo', value: '0.3g / 100g' },
            { name: 'Chất xơ', value: '1.7g / 100g' },
            { name: 'Vitamin C', value: '7.2mg / 100g' },
        ],
        rating: 4.5,
        reviewCount: 15,
    },
    {
        id: '7',
        name: 'Trái cây cắt sẵn thập cẩm',
        slug: 'trai-cay-cat-san-thap-cam',
        description: 'Bao gồm các loại trái cây tươi ngon như dứa, táo, dưa hấu, thanh long, nho... được cắt sẵn và đóng hộp tiện lợi. Lý tưởng cho bữa sáng, ăn vặt hoặc tráng miệng.',
        price: 85000,
        images: [
            'https://images.unsplash.com/photo-1578829779691-99b60bd8c7be?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80',
            'https://images.unsplash.com/photo-1611080626919-7cf5a9dbab12?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80',
        ],
        category: {
            id: '3',
            name: 'Trái cây cắt sẵn',
            slug: 'trai-cay-cat-san',
        },
        isFeatured: false,
        isNew: true,
        stock: 15,
        unit: 'hộp',
        weight: '400g',
        origin: 'Việt Nam',
        nutritionFacts: [
            { name: 'Calo', value: '~50-70 kcal / 100g' },
            { name: 'Carbohydrate', value: '~12-18g / 100g' },
            { name: 'Chất đạm', value: '~0.5-1g / 100g' },
            { name: 'Chất béo', value: '~0.1-0.3g / 100g' },
            { name: 'Chất xơ', value: '~1-2.5g / 100g' },
            { name: 'Vitamin C', value: '~20-50mg / 100g' },
        ],
        rating: 4.3,
        reviewCount: 22,
    },
    {
        id: '8',
        name: 'Hộp quà trái cây cao cấp',
        slug: 'hop-qua-trai-cay-cao-cap',
        description: 'Hộp quà trái cây cao cấp gồm các loại trái cây nhập khẩu và nội địa tuyển chọn, được sắp xếp đẹp mắt trong hộp quà sang trọng. Lựa chọn hoàn hảo cho các dịp lễ, tết, sinh nhật hoặc làm quà tặng đối tác.',
        price: 885000,
        images: [
            'https://images.unsplash.com/photo-1519162418598-c48e021559e7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1674&q=80',
            'https://images.unsplash.com/photo-1490885578174-acda8905c2c6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1769&q=80',
        ],
        category: {
            id: '4',
            name: 'Quà tặng trái cây',
            slug: 'qua-tang-trai-cay',
        },
        isFeatured: false,
        isNew: true,
        stock: 10,
        unit: 'hộp',
        weight: '~5kg',
        origin: 'Nhiều nguồn',
        nutritionFacts: [],
        rating: 4.9,
        reviewCount: 12,
    },
    {
        id: '10',
        name: 'Dưa lưới Taki (hộp 1 trái)',
        slug: 'dua-luoi-taki',
        description: 'Dưa lưới Taki được trồng theo phương pháp hữu cơ, đạt tiêu chuẩn VietGAP. Trái dưa có hương thơm đặc trưng, vỏ mỏng, thịt dày, ngọt mát và nhiều dinh dưỡng.',
        price: 95000,
        originalPrice: 120000,
        images: [
            'https://images.unsplash.com/photo-1571575173700-afb9492e6a50?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1776&q=80',
            'https://images.unsplash.com/photo-1587049633312-d628ae50a8ae?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        ],
        category: {
            id: '1',
            name: 'Trái cây Việt Nam',
            slug: 'trai-cay-viet-nam',
        },
        isFeatured: false,
        isNew: true,
        stock: 50,
        disabled: true,
        unit: 'box',
        weight: '1.5-1.8kg/trái',
        origin: 'Việt Nam',
        nutritionFacts: [
            { name: 'Calo', value: '34 kcal' },
            { name: 'Carbohydrate', value: '8g' },
            { name: 'Vitamin C', value: '36mg' },
            { name: 'Vitamin A', value: '20μg' },
            { name: 'Kali', value: '267mg' },
        ],
        rating: 4.7,
        reviewCount: 32,
    },
];

// API functions
// Get all categories
export const getCategories = async (): Promise<Category[]> => {
    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 300));
    return CATEGORIES;
};

// Get category by slug
export const getCategoryBySlug = async (slug: string): Promise<Category | null> => {
    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 300));
    return CATEGORIES.find((category) => category.slug === slug) || null;
};

// Get all products
export const getProducts = async (options?: {
    featured?: boolean;
    new?: boolean;
    categoryId?: string;
    limit?: number;
}): Promise<Product[]> => {
    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 500));

    let filteredProducts = [...PRODUCTS];

    if (options?.featured) {
        filteredProducts = filteredProducts.filter((product) => product.isFeatured);
    }

    if (options?.new) {
        filteredProducts = filteredProducts.filter((product) => product.isNew);
    }

    if (options?.categoryId) {
        filteredProducts = filteredProducts.filter((product) => product.category.id === options.categoryId);
    }

    if (options?.limit && options.limit > 0) {
        filteredProducts = filteredProducts.slice(0, options.limit);
    }

    return filteredProducts;
};

// Get product by ID
export const getProductById = async (id: string): Promise<Product | null> => {
    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 500));
    return PRODUCTS.find((product) => product.id === id) || null;
};

// Get product by slug
export const getProductBySlug = async (slug: string): Promise<Product | null> => {
    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 500));
    return PRODUCTS.find((product) => product.slug === slug) || null;
};

// Get related products
export const getRelatedProducts = async (productId: string, limit: number = 4): Promise<Product[]> => {
    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 500));

    const currentProduct = PRODUCTS.find((product) => product.id === productId);
    if (!currentProduct) return [];

    return PRODUCTS
        .filter((product) =>
            product.id !== productId &&
            product.category.id === currentProduct.category.id
        )
        .slice(0, limit);
};



